import { FC, useContext } from 'react';

import { Form as FormAntd } from 'antd';

import {
  ColSize,
  DatePickerForm,
  InputForm,
  RadioForm,
  RowSize,
  SelectForm,
} from '../../../../../../../../../../../shared/components';
import { SectionQuotation } from '../../../../../../../shared';

import { StepFourFormContext } from '../../../../contexts/StepFourForm';

import { ValidateForm } from '../../../../../../../../../../../shared/utils';
import { DECISION_TYPE, OPTION_YES_OR_NOT } from '../../../../../../../../../../../shared/interfaces';

interface TrackersProps {
  tabKey: number;
}

export const Trackers: FC<TrackersProps> = ({ tabKey }) => {
  const validateForm = new ValidateForm();

  const { tabsSectionForm, trackersList, isLoadingTrackersList } =
    useContext(StepFourFormContext);

  const hasTrackers: string = FormAntd.useWatch(
    `trackers-hasTrackers-tab-${tabKey}`,
    tabsSectionForm
  );

  const handleChange = () => {
    tabsSectionForm?.resetFields([`trackers-trackerBrand-tab-${tabKey}`]);
    tabsSectionForm?.resetFields([`trackers-contactName-tab-${tabKey}`]);
    tabsSectionForm?.resetFields([`trackers-phone-tab-${tabKey}`]);
    tabsSectionForm?.resetFields([`trackers-email-tab-${tabKey}`]);
    tabsSectionForm?.resetFields([`trackers-hoursForContact-tab-${tabKey}`]);
  };

  return (
    <SectionQuotation title='Rastreador' hasCard={false}>
      <RowSize>
        <ColSize size={25}>
          <RadioForm
            formProps={{
              initialValue: false,
              label: 'Tiene Rastreador:',
              name: `trackers-hasTrackers-tab-${tabKey}`,
            }}
            radioProps={{ onChange: handleChange }}
            options={OPTION_YES_OR_NOT}
          />
        </ColSize>
      </RowSize>
      <RowSize>
        {hasTrackers === DECISION_TYPE.YES ? (
          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: 'Marca Rastreador:',
                name: `trackers-trackerBrand-tab-${tabKey}`,
                rules: validateForm.generateRules({
                  label: 'marca de rastreador',
                  rules: ['required'],
                }),
              }}
              selectProps={{
                options: trackersList,
                loading: isLoadingTrackersList,
              }}
            />
          </ColSize>
        ) : (
          <SectionQuotation title='Información de Contacto' hasCard={false}>
            <RowSize>
              <ColSize size={25}>
                <InputForm
                  formProps={{
                    label: 'Nombre:',
                    name: `trackers-contactName-tab-${tabKey}`,
                    rules: validateForm.generateRules({
                      label: 'nombre de contacto',
                      rules: ['required', 'text'],
                    }),
                  }}
                />
              </ColSize>
              <ColSize size={25}>
                <InputForm
                  formProps={{
                    label: 'Teléfono:',
                    name: `trackers-phone-tab-${tabKey}`,
                    rules: validateForm.generateRules({
                      label: 'teléfono de contacto',
                      rules: ['required', 'phone'],
                    }),
                  }}
                />
              </ColSize>
              <ColSize size={25}>
                <InputForm
                  formProps={{
                    label: 'Correo Electrónico:',
                    name: `trackers-email-tab-${tabKey}`,
                    rules: validateForm.generateRules({
                      label: 'correo electrónico',
                      rules: ['required', 'email'],
                    }),
                  }}
                />
              </ColSize>
              <ColSize size={25}>
                <DatePickerForm
                  formProps={{
                    label: 'Disponibilidad Horaria:',
                    name: `trackers-hoursForContact-tab-${tabKey}`,
                    rules: validateForm.generateRules({
                      label: 'disponibilidad horaria',
                      rules: ['required'],
                    }),
                  }}
                  isRangePicker
                  rangePickerProps={{
                    format: 'HH:mm',
                    picker: 'time',
                    showTime: { format: 'HH:mm' },
                  }}
                />
              </ColSize>
            </RowSize>
          </SectionQuotation>
        )}
      </RowSize>
    </SectionQuotation>
  );
};
